import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";

interface PageTitleComponentProps {
  title?: string;
  description?: string;
  align?: "center" | "left" | "right";
  titleAlign?: "center" | "left" | "right";
  descriptionAlign?: "center" | "left" | "right";
  className?: string;
}

export const PageTitleComponent = memo(function PageTitleComponent({
  title,
  description,
  align = "left",
  titleAlign = "left",
  descriptionAlign = "left",
  className,
}: PageTitleComponentProps) {
  return (
    <div
      className={cn(
        "flex flex-col gap-4 w-full",
        {
          "items-center justify-center": align === "center",
          "items-start justify-start": align === "left",
          "items-end justify-end": align === "right",
        },
        className,
      )}
    >
      {title && (
        <h2
          className={cn("text-black", textVariants.largeTitle, {
            "text-center": titleAlign === "center",
            "text-left": titleAlign === "left",
            "text-right": titleAlign === "right",
          })}
        >
          {title}
        </h2>
      )}
      {description && (
        <p
          className={cn(textVariants.bodySingleLine, "text-[#5A5757]", {
            "text-center": descriptionAlign === "center",
            "text-left": descriptionAlign === "left",
            "text-right": descriptionAlign === "right",
          })}
        >
          {description}
        </p>
      )}
    </div>
  );
});
